// Parseo y validación compartida de listas de chips pegadas desde Notas del
// iPhone, WhatsApp o Excel. Un único lugar para toda la app (Inventario
// Inicial, Sesión de Inventario, Venta a matadero, Venta para cría,
// Traslados) — así el comportamiento es siempre el mismo.

// Quita numeración ("1.", "1)", "1:") y viñetas ("-", "*", "•", "·") al
// inicio de una línea, sin tocar el resto del contenido.
function stripLineNumbering(line) {
  return line
    .replace(/^\s*[-*•·]+\s*/, "")
    .replace(/^\s*\d+[.):]\s*/, "");
}

// Deja solo dígitos. Los chips de esta app son siempre numéricos.
function onlyDigits(s) {
  return String(s || "").replace(/[^0-9]/g, "");
}

const MIN_CHIP_LEN = 6;

/**
 * Lista simple de chips (sin peso). Acepta cualquier combinación de saltos
 * de línea, comas, punto y coma, tabulaciones y espacios como separador —
 * y tolera líneas numeradas o con viñetas.
 * Devuelve { valid: string[] (sin duplicados), duplicates: number, invalid: string[] }.
 */
export function parseChipTokens(rawText) {
  const lines = String(rawText || "").split(/\r?\n/);
  const seen = new Set();
  const valid = [];
  const invalid = [];
  let duplicates = 0;
  for (const rawLine of lines) {
    if (!rawLine.trim()) continue;
    const cleaned = stripLineNumbering(rawLine.trim());
    const pieces = cleaned.split(/[,;\t]+|\s+/).map((p) => p.trim()).filter(Boolean);
    for (const piece of pieces) {
      const digits = onlyDigits(piece);
      if (!digits || digits.length < MIN_CHIP_LEN) { invalid.push(piece); continue; }
      if (seen.has(digits)) { duplicates++; continue; }
      seen.add(digits);
      valid.push(digits);
    }
  }
  return { valid, duplicates, invalid };
}

/**
 * Lista de chips con peso opcional, un animal por línea: "chip,peso",
 * "chip peso" o solo "chip" (el peso queda vacío para completar después).
 * Devuelve { valid: {chip_code, weight_kg}[], duplicates: number, invalid: string[] }.
 */
export function parseChipWeightList(rawText) {
  const lines = String(rawText || "").split(/\r?\n/);
  const seen = new Set();
  const valid = [];
  const invalid = [];
  let duplicates = 0;
  for (const rawLine of lines) {
    if (!rawLine.trim()) continue;
    const cleaned = stripLineNumbering(rawLine.trim());
    const parts = cleaned.split(/[,;\t]+|\s+/).map((p) => p.trim()).filter(Boolean);
    if (!parts.length) continue;
    const digits = onlyDigits(parts[0]);
    if (!digits || digits.length < MIN_CHIP_LEN) { invalid.push(rawLine.trim()); continue; }
    if (seen.has(digits)) { duplicates++; continue; }
    let weight_kg;
    if (parts[1]) {
      const n = parseFloat(parts[1].replace(",", "."));
      if (!isNaN(n)) weight_kg = n;
    }
    seen.add(digits);
    valid.push({ chip_code: digits, weight_kg });
  }
  return { valid, duplicates, invalid };
}

/** Resumen legible: "48 chips reconocidos · 2 repetidos (se ignoran) · 1 no válido". */
export function summarizeParse({ valid, duplicates, invalid }) {
  const parts = [`${valid.length} chip${valid.length === 1 ? "" : "s"} reconocido${valid.length === 1 ? "" : "s"}`];
  if (duplicates > 0) parts.push(`${duplicates} repetido${duplicates === 1 ? "" : "s"} (se ignoran)`);
  if (invalid.length > 0) parts.push(`${invalid.length} no válido${invalid.length === 1 ? "" : "s"}`);
  return parts.join(" · ");
}

/** Pega del portapapeles con un toque. Devuelve null si el navegador no lo permite. */
export async function readClipboardText() {
  try {
    if (!navigator.clipboard?.readText) return null;
    const text = await navigator.clipboard.readText();
    return text || "";
  } catch (_) {
    return null;
  }
}
